import {Component, Inject, Input} from '@angular/core';
import {EnvVariables} from '../../../environment-variables/environment-variables.token';
import {PrismConfigOptions} from '../../../environment-variables/environment-variables.interface';

/**
 * Components that places injects the prism logo
 */
@Component({
  selector: 'advtech-prism-logo',
  templateUrl: './prism-logo.component.html',
})
export class PrismLogoComponent {
  /**
   * logo color
   * @type {string}
   */
  color: string = 'black';

  /**
   * Lets the template know whether it should display the text
   * @type {boolean}
   */
  @Input()
  displayText: boolean = true;

  /**
   * Can be left, center, or right
   * @type {string}
   */
  @Input()
  justifyContent: string = 'center';

  constructor(@Inject(EnvVariables) config: PrismConfigOptions) {
    this.color = config.logoColor;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/prism-logo/prism-logo.component.ts